import { PaxType } from "@/lib/redux/features/flight/type"

export const getPassengerTitleI18nKey = (gender: boolean, paxType?: PaxType) => {
  if (paxType === "CHILD" || paxType === "INFANT") {
    return gender ? "common.boy" : "common.girl"
  }
  return gender ? "common.mr" : "common.mrs"
}
